<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="470">
    <v-card >
        <v-toolbar dense color="secondary" dark>
            {{state=='new'?'New':'Add'}} Category
             <v-spacer/>
              <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text >
          <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                    v-model="item.name"
                    label="Category Name"
                    :rules="textRules"
                    dense
                    outlined
                    required
                />
                <v-text-field
                    v-model="item.description"
                    label="Category description"
                    :rules="textRules"
                    dense
                    outlined
                    required
                />
          </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded  @click="text ='close', emitToParent('close')">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn small color="success"  rounded  @click="validate()">{{state=='new'?'Add':'Save'}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data: () => ({
        valid: true,
        item: {},
        textRules: [
        v => !!v || 'Field is required'
      ],
    }),
  props: {
    show: {
        type: Boolean,
        default: false
    },
    state: {
      type: String,
      default: 'new'
    },
    category: {
      type: Object,
      default: ()=>{}
    }
  },
  watch:{
      show(val) {
          if(val){
            this.state == 'new' ? this.item= {}:this.item=this.category
         }
      }
  },
  methods: {
        validate () {
        if (this.$refs.form.validate()) {
            this.Save()
        }
      },
     Save() {
        this.$http.post(this.state=='new'?"category/add":"category/update", this.item).then(response => {
            this.GET_RESPONSE(response)
            this.$emit('DialogEvent', 'close')
          }).catch(e => {
            console.log(e.data)
        })
    },
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    }
  }
}
</script>
